/* ==============================================================================================
 * GET URL PARAMETERS UTIL
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	/**
	 * @return string
	 */
	Sushi.Util.getUrlParameter = function (location, name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		var results = regex.exec(location);

		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	};

})(Sushi || (Sushi = {}));
